module.exports = __webpack_public_path__ + "img/h5.59cfa05f.png";